var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { generateRoute, getLang, translate } from '@js/common/helpers';
import { FollowButton } from './FollowButton';
import { NotifyMeButton } from './NotifyMeButton';
import { getEventEnd } from '../utils/schedule';
function getShowState(event) {
    var now = new Date();
    var start = new Date(event.date);
    var end = getEventEnd(event);
    if (now >= start && now <= end) {
        return 'live';
    }
    if (now > end) {
        return event.collection_is_active ? 'past-available' : 'past-unavailable';
    }
    return 'upcoming';
}
function buildCollectionUrl(event, season, type) {
    var params = {
        type: type,
        designer: event.designer_slug,
        season: season,
    };
    if (!event.city) {
        return generateRoute('collection_show', params);
    }
    return generateRoute('collection_show', __assign(__assign({}, params), { city: event.city.slug }));
}
export function ShowCard(_a) {
    var event = _a.event, season = _a.season, type = _a.type, userEmail = _a.userEmail;
    var state = getShowState(event);
    var time = new Date(event.date).toLocaleTimeString(getLang(), { hour: '2-digit', minute: '2-digit' });
    return (React.createElement("div", { className: "show-card show-card--" + state },
        state === 'live' && React.createElement("span", { className: "show-card-live-badge" }, translate('calendar.live_now')),
        React.createElement("span", { className: "show-card-time" }, time),
        React.createElement("span", { className: "show-card-name" }, event.name),
        state === 'past-available' && (React.createElement("a", { className: "btn", href: buildCollectionUrl(event, season, type) }, translate('calendar.view_collection'))),
        state === 'past-unavailable' && React.createElement(NotifyMeButton, { slug: event.slug, userEmail: userEmail }),
        (state === 'live' || state === 'upcoming') && React.createElement(FollowButton, { event: event, userEmail: userEmail })));
}
